import client from './client'

const fetchHverfi = () => {
  return client.get('/items/hverfi', {
    fields: [
      'key',
      'title',
      'body',
      'body_full',
      'body_gogn',
      'gogn.item.*',
      'image.data',
      'image.width',
      'image.height',
      'meta',
      'tegund',
      'lodir.*.*',
      'deiliskipulag.*',
      'afangar.title',
      'afangar.slug',
      'afangar.deiliskipulag.body',
    ],
  })
}

export default fetchHverfi
